// src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFoundPage.css';

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-description">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-button primary">
            Return Home
          </Link>
          <Link to="/booking" className="not-found-button secondary">
            Book a Ride
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
